<div class="sidenav-container" *ngIf="isRosterPage">
  <app-roster-sidenav></app-roster-sidenav>
</div>

<div class="sidenav-container" *ngIf="isWorklogPage">
  <app-worklog-sidenav></app-worklog-sidenav>
</div>

<div class="sidenav-container" *ngIf="isAdhocServicePage">
  <app-adhoc-service-sidenav></app-adhoc-service-sidenav>
</div>

<div class="container">
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
